/**
 * GPC(Global Privacy Control, `Sec-GPC: 1`)와 DNT(Do Not Track) 신호를 감지한다.
 *
 * - GPC는 California CCPA/EU GDPR 환경에서 표준 채택되어 가는 헤더.
 * - DNT는 deprecated이나 일부 브라우저(Firefox)에서 여전히 노출.
 *
 * 두 신호 중 하나라도 활성이면 `track()` 호출을 no-op 처리한다.
 * 사용자가 명시적으로 `respectPrivacySignals: false`로 비활성화 가능 (기본 활성).
 */
const hasPrivacySignal = (): boolean => {
  if (typeof navigator === 'undefined') return false
  const nav = navigator as Navigator & { globalPrivacyControl?: boolean; doNotTrack?: string }
  if (nav.globalPrivacyControl === true) return true
  if (nav.doNotTrack === '1') return true
  return false
}

export { hasPrivacySignal }
